import ColorSwatches from "~/components/ColorSwatches/ColorSwatches";
import * as React from 'react';
export default {
  ColorSwatches,
  React
};